export default __webpack_public_path__ + "static/media/IledeFrance.776ef687.png";